// extracted by mini-css-extract-plugin
export default {"cls1":"RemovedItemNotice-cls1_v6n","cls2":"RemovedItemNotice-cls2_mva RemovedItemNotice-cls1_v6n"};